import React__default, { useState, useMemo } from 'react';
import { SwanCollectionContext } from './collection.context.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function CollectionContextProvider(props) {
    const { children, items } = props;
    const [disabledKeys, setDisabledKeys] = useState(props.disabledKeys);
    const [prevDisabledKeys, setPrevDisabledKeys] = useState(props.disabledKeys);
    if (disabledKeys !== prevDisabledKeys) {
        setDisabledKeys(disabledKeys);
        setPrevDisabledKeys(disabledKeys);
    }
    const [childItems, setChildItems] = useState();
    const contextValue = useMemo(()=>({
            items,
            childItems,
            setChildItems,
            disabledKeys,
            setDisabledKeys
        }), [
        items,
        childItems,
        setChildItems,
        disabledKeys,
        setDisabledKeys
    ]);
    return /*#__PURE__*/ React__default.createElement(SwanCollectionContext.Provider, {
        value: contextValue
    }, children);
}

export { CollectionContextProvider };
